import { FormField } from '../../../types/form-builder.types';
import { Input } from '@shondalai/ui-commons';

interface CurrencyFieldProps {
  field: FormField;
  value: string | number;
  onChange: (value: string) => void;
}

export function CurrencyField({ field, value, onChange }: CurrencyFieldProps) {
  const config = field.config;
  const currencySymbol = (config as any).currencySymbol || '$';
  const disabled = (config as any).disabled;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    // Allow only numbers and decimal point
    if (/^\d*\.?\d{0,2}$/.test(inputValue) || inputValue === '') {
      onChange(inputValue);
    }
  };

  return (
    <div className="easyforms-currency-field">
      <div className="relative">
        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground">
          {currencySymbol}
        </span>
        <Input
          id={field.id}
          type="text"
          value={value || ''}
          onChange={handleChange}
          placeholder={(config as any).placeholder || '0.00'}
          disabled={disabled}
          className="!pl-6"
        />
      </div>
      {config.helpText && (
        <p className="text-xs text-muted-foreground mt-1">{config.helpText}</p>
      )}
    </div>
  );
}

